let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ewzej")).then(() => parcelRequire('9fiTs'));